export default __webpack_public_path__ + "static/media/rabbit.c9d9a0ea.png";